import { FC, useEffect } from 'react'
import { useMyDispatch } from '../../featureSliced/shared/hooks/useMyDispatch'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { getTableData } from 'featureSliced/shared/store/reducers/CommonReducer/actionCreator'
import { RenderIf } from '../RenderIf'
import { handleLocalStorage } from '../../featureSliced/shared/utils/handleLocalStorage'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import {
  HeaderStyled,
  HeaderLogo,
  TableCaption,
  TableCaptionNumber,
  TableCaptionText,
  WishListContainer,
} from './styled'
import heart from 'assets/hearts/empty_l.svg'
import chevronLeft from 'assets/chevronLeft.svg'
import { useTranslations } from '../../featureSliced/shared/hooks/useTranslations'
import clickAndCollectLogo from 'assets/prompt/clickAndCollect.svg'
import qrMenuLogo from 'assets/prompt/qrMenu.svg'

export const Header: FC = () => {
  // Hooks
  const t = useTranslations()
  const dispatch = useMyDispatch()
  // const guid = handleLocalStorage('guid')
  const { guid, dataEnc } = handleLocalStorage(['guid', 'dataEnc'])
  const location = useLocation()
  const navigate = useNavigate()

  const [searchParams] = useSearchParams()
  const table = searchParams.get('table')

  // Store
  const { wishlist } = useMySelector((state) => state)
  const { logoImage } = useMySelector((state) => state.app.interfaceStyles)
  const { tableData, isTopScrolled } = useMySelector((state) => state.common)

  // useEffects
  useEffect(() => {
    if ((guid || dataEnc) && table) {
      dispatch(getTableData({ table }))
    }
  }, [guid, dataEnc, table]) // eslint-disable-line

  // Functions
  const handleBackClick = () => {
    const isMenuOrRest =
      location.pathname === '/menu' || location.pathname === '/restaurants'
    if (!isMenuOrRest) {
      navigate(-1)
    }
    if (isMenuOrRest && table) {
      navigate(`/?table=${table}`)
    }
    if (isMenuOrRest && !table) {
      navigate(`/`)
    }
  }

  const moveToWishlist = () => {
    if (table) {
      navigate(`/wishlist?table=${table}`)
    }
    if (!table) {
      navigate('/wishlist')
    }
  }

  const getImageSrc = (logoImage?: string) => {
    if (process.env.REACT_APP_IS_CLIC === '0') {
      return logoImage || qrMenuLogo
    }
    if (process.env.REACT_APP_IS_CLIC === '1') {
      return logoImage || clickAndCollectLogo
    }
  }

  return (
    <HeaderStyled isTopScrolled={isTopScrolled} data-testid="header_test-id">
      <img
        src={chevronLeft}
        alt="Back"
        onClick={handleBackClick}
        width="40"
        height="40"
      />
      {/* NOTE: HeaderLogo is temporary hiden */}
      {/* <HeaderLogo
        src={getImageSrc(logoImage)}
        height="35"
        width="35"
        alt="Logo"
      /> */}
      <div />
      <RenderIf
        condition={
          location.pathname !== '/wishlist' &&
          location.pathname !== '/loyaltyCard' &&
          location.pathname !== '/restaurants'
        }
      >
        <WishListContainer
          onClick={moveToWishlist}
          count={wishlist?.length}
          // withMargin={true}
          withMargin={!!(tableData?.caption || tableData?.objectTag)}
        >
          <img src={heart} alt="wishlist" width="25" height="22" />
        </WishListContainer>
      </RenderIf>
      <TableCaption>
        <TableCaptionNumber>
          {tableData?.caption || tableData?.objectTag}
        </TableCaptionNumber>
        <RenderIf condition={!!(tableData?.caption || tableData?.objectTag)}>
          <TableCaptionText>{t('common.tableNumber')}</TableCaptionText>
        </RenderIf>
      </TableCaption>
    </HeaderStyled>
  )
}
